module.exports = __webpack_public_path__ + "img/third_at_piano.62cd0e63.jpg";